import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CreateMessageComponent} from './create-message.component';
import {FileUploadModule} from 'ng2-file-upload';
import {LoadingModule} from '../../../../../components/common/loading/loading.module';
import {SingleMessageModule} from '../single-message/single-message.module';
import {RichTextEditorModule} from '../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {ButtonModule} from '../../../../core/component/button/button.module';
import {InputTextModule} from '../../../../core/component/input-text/input-text.module';
import {InputTextareaModule} from "../../../../core/component/input-textarea/input-textarea.module";
import {
    CreateMessageAddAttachmentDialogComponent
} from "../../../impl/component/create-message-add-attachment-dialog/create-message-add-attachment-dialog.component";
import {SummaryFieldModule} from "../../../../core/component/summary-field/summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FileUploadModule,
        LoadingModule,
        RichTextEditorModule,
        SingleMessageModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        CreateMessageAddAttachmentDialogComponent,
        SummaryFieldModule,
    ],
    declarations: [
        CreateMessageComponent,
    ],
    exports: [
        CreateMessageComponent
    ],
})
export class CreateMessageModule{}
